import _head from 'lodash/head';
import { FISHERMAN_BUSINESS_TYPE_SCHEMA_TYPE, DEFAULT_SCHEMA_TYPE } from './constants';
export function getBusinessSchemaType(businessCategories) {
  var firstCategory = _head(businessCategories);
  if (!firstCategory) {
    return DEFAULT_SCHEMA_TYPE;
  }
  var category = firstCategory.category;
  return FISHERMAN_BUSINESS_TYPE_SCHEMA_TYPE[category] || DEFAULT_SCHEMA_TYPE;
}